<template>
  <div class="card-container">
    <common-top-form
      ref="commonTopForm"
      selectShowPower="/newmonthlylist/select"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      @openAddDialog="openAddDialog"
      addShowPower="/newmonthlylist/add"
      :needCheck="needCheck"
      @check="handleTopCheck"
    >
      <el-form-item label="排行榜名称">
        <el-select clearable v-model="formModel.rankId">
          <el-option
            v-for="item in gameName"
            :key="item.id"
            :label="item.gameName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="代理商ID">
        <el-input v-model="formModel.agentId" placeholder="请输入"></el-input>
      </el-form-item>

      <el-form-item label="更新时间">
        <el-date-picker
          v-model="time"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="rank"
        label="排名"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="rankName"
        label="排行榜名称"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="phone"
        label="手机号"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="realName"
        label="姓名"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="agentId"
        label="代理商ID"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="integral"
        label="积分"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="updateTime"
        label="更新时间"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        v-if="hasPerm('/newmonthlylist/caozuo')"
        label="操作"
        min-width="120"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button type="text" @click="openAddDialog(scope.row, true)"
            >修改
          </el-button>
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="itemId ? '修改' : '添加'"
      :model="dialogModel"
      :submitData="dialogData"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
      class="note"
      labelWidth="120px"
      dialogWidth="439px"
    >
      <el-form-item label="代理商ID" prop="agentId">
        <el-input-number
          :disabled="flag"
          v-model="dialogModel.agentId"
          :min="0"
          :max="999999999"
          :step="0"
          :precision="0"
          :controls="false"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item>
      <div class="flex-row vertical-center mem-name">
        <p>代理商名称：</p>
        <p v-if="memName.phoneNumber">
          {{
            memName.realName || memName.nickName || "用户" + memName.phoneNumber
          }}
        </p>
      </div>
      <el-form-item label="排行榜名称" prop="rankId">
        <el-select
          :disabled="flag"
          style="width: 198px"
          v-model="dialogModel.rankId"
        >
          <el-option
            v-for="item in gameName"
            :key="item.id"
            :label="item.gameName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="积分" prop="integral">
        <el-input-number
          style="width: 180px"
          v-model="dialogModel.integral"
          :min="0"
          :max="999999999"
          :step="0"
          :precision="0"
          :controls="false"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import APPService from "service/APPService";
import TimeRange from "service/constant/TimeRange";
import FormDialog from "../../dialog/FormDialog";
import FinanceService from "service/FinanceService";
import Month from "service/constant/Month";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "newmonthlylist",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
  },
  data() {
    return {
      time: TimeRange.monthRange,
      Month: Month,
      formModel: {
        agentId: "",
        rankId: "",
      },
      tableData: [],
      memName: {},
      itemId: "",
      flag: "",
      dialogModel: {
        agentId: undefined,
        rankId: "",
        integral: undefined,
      },
      submitService: APPService.newmonthlylistList,
      params: {},
      page: {},
      isPage: false,
      gameName: [
        // {
        //   id: "",
        //   gameName: "全部",
        // },
      ],
      dialogRules: {
        agentId: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入"));
              } else if (!/^\d+$/.test(value)) {
                callback(new Error("请输入纯数字"));
              } else {
                this.getRealNameByPhone(value, (res) => {
                  if (res.respCode == "0000") {
                    this.memName = res.contents;
                    this.memId = res.contents.id;
                    if (!this.memName.id) {
                      callback(new Error("查询不到此用户"));
                      this.memName = "";
                      this.memId = "";
                    } else {
                      callback();
                    }
                  } else {
                    callback(new Error("查询不到此用户"));
                    this.memName = "";
                    this.memId = "";
                  }
                });
              }
            },
          },
        ],
        rankId: [
          {
            required: true,
            message: "请选择",
          },
        ],
        integral: [
          {
            required: true,
            message: "请输入",
          },
        ],
      },
      needCheck: true,
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
  },
  computed: {
    submitData() {
      if (this.time == null || this.time == "") {
        this.time = [];
      }
      const params = {
        agentId: this.formModel.agentId,
        rankId: this.formModel.rankId,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      if (this.time.length) {
        params.startTime = this.time[0];
        params.endTime = this.time[1];
      }
      return params;
    },
    dialogData() {
      const params = {
        agentId: this.dialogModel.agentId,
        rankId: this.dialogModel.rankId,
        integral: this.dialogModel.integral,
      };
      // if (this.itemId) {
      //   params.id = this.itemId;
      // }
      return params;
    },
    dialogService() {
      return APPService.newmonthlylistEdit;
    },
    ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
  },
  methods: {
    load() {
      this.formModel = {
        month: "",
      };
      this.page = this.$refs.commonTable.page;
      // this.getList();
      this.getgameName();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    getgameName() {
      this.doLoad(
        APPService.newrankingmanageList,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            // this.gameName = [...this.gameName, ...res.contents.rows];
            this.gameName = res.contents.rows;
          });
        },
        "信息获取失败"
      );
    },
    getRealNameByPhone(val, onSuccess) {
      const params = {
        tatSimpleId: this.tatId,
        userId: val,
      };
      this.doLoad(
        FinanceService.getRealNameByPhone,
        params,
        (res) => {
          onSuccess && onSuccess(res);
        },
        "信息获取失败"
      );
    },
    openAddDialog(item, flag) {
      this.flag = flag;
      this.itemId = item ? item.id : "";
      if (this.itemId) {
        this.isFlag = true;
        this.dialogModel = JSON.parse(JSON.stringify(item));
        this.$nextTick(() => {
          this.$refs.formDialog.validateField("agentId");
        });
      }
      this.memName = {};
      this.$refs.formDialog.open();
    },

    dialogClose() {
      this.dialogModel = {
        agentId: undefined,
        rankId: "",
        integral: undefined,
      };
      this.itemId = "";
      this.flag = "";
      this.memName = {};
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
        this.needCheck = true;
      });
    },
    handleTopCheck() {
      if (!this.formModel.rankId) {
        this.showWarming("请选择排行榜名称");
        return;
      }
      this.needCheck = false;
      this.$refs.commonTopForm.submit();
    },
  },
};
</script>

<style scoped>
p {
  font-size: 14px;
  color: #000;
  font-weight: bold;
  margin-bottom: 30px;
}

.mem-name p {
  margin-bottom: 20px;
  vertical-align: middle;
  line-height: 40px;
  color: rgba(170, 170, 170, 1);
}

.mem-name p:first-child {
  display: inline-block;
  width: 106px;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/view/page/NewRankIng/NewMonthlyList.vue